import React  from 'react';
import PropTypes from 'prop-types';

const Container = (props) => {
    return (
        <div className="container-fluid">{props.children}</div>
    );
};

Container.propTypes = {
    children: PropTypes.element.isRequired,
};

export default Container;



// WEBPACK FOOTER //
// ./src/components/chunks/Container.js